import uiRouter from '@uirouter/angularjs';

import { AuthServiceModule } from 'services/auth/auth.service';
import { errorPageComponent } from './error.component';

export const ErrorPageModule = angular
    .module('app.pages.error', [
        AuthServiceModule,
        uiRouter
    ])
    .component('errorPage', errorPageComponent)
    .config(($stateProvider) => {
        $stateProvider.state('error', {
            url: '/error',
            component: 'errorPage',
            data: {
                page: 'error'
            }
        });
    }).name;


// WEBPACK FOOTER //
// ./src/app/pages/error/error.module.js